var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "get-support-search-result" },
    [
      _vm.hasContentResults
        ? [
            _c(
              "div",
              { staticClass: "rb-get-support-search-result--total-pages" },
              [_vm._v("\n      " + _vm._s(_vm.getTotalPagesOfLabel) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "rb-get-support-search-result--list" },
              _vm._l(_vm.contentdata, function (content) {
                return _c(
                  "li",
                  {
                    key: content.url,
                    staticClass: "rb-get-support-search-result--list-item",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "rb-get-support-search-result--list-item-link",
                        attrs: { href: content.link },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(content.title) + "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "rb-get-support-search-result--list-item-description",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(content.description) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("rb-loading", { attrs: { loading: _vm.loading && _vm.booted } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rb-get-support-search-result--current-page" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translation("get_support.you_are_seeing")) +
                    " " +
                    _vm._s(_vm.contentdata.length) +
                    "\n      " +
                    _vm._s(_vm.translation("get_support.pages_of")) +
                    " " +
                    _vm._s(_vm.numberOfTotalPages) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.isLoadMoreVisible
              ? _c(
                  "div",
                  { staticClass: "rb-get-support-search-result--load-more" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "rb-btn rb-btn--black",
                        attrs: {
                          "data-element-id": "X_GetSupport_Results_Section",
                          "data-description": "LoadMore",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.loadMorePages()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.translation("get_support.load_more")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.canComponentBeDisplayed
        ? [
            _c(
              "h1",
              {
                staticClass:
                  "rb-get-support__title rb-get-support-search-result__no-result-title",
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translation("get_support.no_results")) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _vm._t("no-results"),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("rb-loading", { attrs: { loading: _vm.loading && !_vm.booted } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }